var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.type,{tag:"component",staticClass:"heading",class:_vm.classList},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.text))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }